const KATAKANA_START = 0x30a1;
const KATAKANA_END = 0x30f6;
const HIRAGANA_OFFSET = 0x60;

function katakanaToHiragana(value: string): string {
  return Array.from(value)
    .map((character) => {
      const codePoint = character.codePointAt(0);

      if (codePoint && codePoint >= KATAKANA_START && codePoint <= KATAKANA_END) {
        return String.fromCodePoint(codePoint - HIRAGANA_OFFSET);
      }

      return character;
    })
    .join("");
}

export function normalizeAdminSearchText(value: string): string {
  return katakanaToHiragana(value)
    .normalize("NFKC")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();
}

export function normalizeAdminSearchTextCompact(value: string): string {
  return normalizeAdminSearchText(value).replace(/\s+/g, "");
}

export function buildAdminSearchHaystack(values: readonly (string | null | undefined)[]): string {
  return values
    .map((value) => normalizeAdminSearchText(value ?? ""))
    .filter((value) => value.length > 0)
    .join(" ");
}

export function adminSearchMatches(query: string, haystack: string): boolean {
  const normalizedQuery = normalizeAdminSearchText(query);

  if (!normalizedQuery) {
    return true;
  }

  const normalizedHaystack = normalizeAdminSearchText(haystack);
  return (
    normalizedHaystack.includes(normalizedQuery)
    || normalizeAdminSearchTextCompact(normalizedHaystack).includes(normalizeAdminSearchTextCompact(normalizedQuery))
  );
}
